import * as types from './types';

export default {
  [types.SET_FUNNELS](_state, funnels) {
    _state.funnels = funnels;
  },
  [types.SET_AVAILABLE_LABELS](_state, labels) {
    _state.availableLabels = labels;
  },
  [types.SET_SELECTED_FUNNEL_ID](_state, funnelId) {
    _state.selectedFunnelId = funnelId;
  },
  [types.SET_CARDS_BY_LABEL](_state, cardsData) {
    // A API agora retorna { [labelId]: { cards: [], meta: {} } }
    // Precisamos adaptar o estado para armazenar isso
    // Se o cardsData vier no formato antigo (array direto), adaptamos

    const formattedData = {};
    const metaData = {};

    Object.keys(cardsData).forEach(labelId => {
      const item = cardsData[labelId];
      if (Array.isArray(item)) {
        // Formato antigo ou fallback
        formattedData[labelId] = item;
        metaData[labelId] = {
          total_count: item.length,
          page: 1,
          has_more: false,
        };
      } else if (item && item.cards) {
        // Novo formato
        formattedData[labelId] = item.cards;
        metaData[labelId] = item.meta;
      } else {
        formattedData[labelId] = [];
        metaData[labelId] = { total_count: 0, page: 1, has_more: false };
      }
    });

    _state.cardsByLabel = formattedData;
    // Precisamos armazenar meta data no state também.
    // Vamos assumir que existe _state.cardsMeta ou adicionar dinamicamente
    _state.cardsMeta = metaData;
  },

  // Mutation para atualizar/paginar cards de uma label específica
  [types.UPDATE_CARDS_FOR_LABEL](_state, { labelId, data, page }) {
    if (!data || !data.cards) return;

    // Inicializa se não existir
    if (!_state.cardsByLabel[labelId]) _state.cardsByLabel[labelId] = [];
    if (!_state.cardsMeta) _state.cardsMeta = {};
    if (!_state.cardsMeta[labelId]) _state.cardsMeta[labelId] = {};

    if (page === 1) {
      // Se for primeira página (seja carga inicial ou nova pesquisa), substitui
      _state.cardsByLabel = { ..._state.cardsByLabel, [labelId]: data.cards };
    } else {
      // Paginação: append
      const currentCards = _state.cardsByLabel[labelId];
      // Evitar duplicatas
      const newCards = data.cards.filter(
        newCard => !currentCards.some(existing => existing.id === newCard.id)
      );
      _state.cardsByLabel[labelId] = [...currentCards, ...newCards];
    }

    // Atualiza meta
    _state.cardsMeta = {
      ..._state.cardsMeta,
      [labelId]: data.meta,
    };
  },

  [types.SET_LOADING](_state, { flag, value }) {
    _state.loading[flag] = value;
  },
  [types.SET_ERROR](_state, { flag, error }) {
    _state.error[flag] = error;
  },
  [types.ADD_FUNNEL](_state, funnel) {
    _state.funnels.push(funnel);
  },
  [types.UPDATE_FUNNEL_IN_LIST](_state, updatedFunnel) {
    const index = _state.funnels.findIndex(f => f.id === updatedFunnel.id);
    if (index !== -1) {
      // Use Vue.set ou splice para reatividade se necessário em Vue 2
      _state.funnels.splice(index, 1, updatedFunnel);
    }
  },
  [types.REMOVE_FUNNEL_FROM_LIST](_state, funnelId) {
    _state.funnels = _state.funnels.filter(f => f.id !== funnelId);
    if (_state.selectedFunnelId === funnelId) {
      _state.selectedFunnelId = _state.funnels.length
        ? _state.funnels[0].id
        : null;
    }
  },
  // Mutation para mover card (atualização otimista)
  [types.MOVE_CARD](_state, { cardId, sourceLabelId, targetLabelId }) {
    const sourceList = _state.cardsByLabel[sourceLabelId] || [];
    const cardIndex = sourceList.findIndex(card => card.id === cardId); // Use o ID real do card

    if (cardIndex !== -1) {
      const [movedCard] = sourceList.splice(cardIndex, 1); // Remove do original

      // Atualiza count na meta da origem
      if (_state.cardsMeta && _state.cardsMeta[sourceLabelId]) {
        _state.cardsMeta[sourceLabelId].total_count = Math.max(
          0,
          (_state.cardsMeta[sourceLabelId].total_count || 0) - 1
        );
      }

      // Adiciona à nova lista (cria se não existir)
      if (!_state.cardsByLabel[targetLabelId]) {
        // Vue.set(_state.cardsByLabel, targetLabelId, []); // Vue 2
        _state.cardsByLabel[targetLabelId] = []; // Vue 3
      }

      _state.cardsByLabel[targetLabelId].push(movedCard);

      // Atualiza count na meta do destino
      if (_state.cardsMeta) {
        if (!_state.cardsMeta[targetLabelId])
          _state.cardsMeta[targetLabelId] = { total_count: 0 };
        _state.cardsMeta[targetLabelId].total_count =
          (_state.cardsMeta[targetLabelId].total_count || 0) + 1;
      }

      // Atualiza a propriedade kanban_label_id se existir no card
      if (movedCard.kanban_label_id) {
        movedCard.kanban_label_id = targetLabelId;
      }

      // Atualiza as labels do card para refletir a mudança visual
      const targetLabel = _state.availableLabels.find(
        label => label.id === targetLabelId
      );

      if (targetLabel) {
        if (movedCard.labels) {
          // Substitui completamente as labels do card pela nova label
          movedCard.labels = [targetLabel.title];
        }

        // Atualiza a regra de estagnação do card baseado na nova etiqueta
        // Isso garante que o badge de estagnação seja atualizado instantaneamente no Kanban
        movedCard.stagnation_rule_days = targetLabel.stagnation_days || 0;
      }
    }
  },
  // Mutation para atualizar dados específicos de um card após uma operação
  [types.UPDATE_CARD_DATA](_state, { labelId, cardId, updatedData }) {
    const cardList = _state.cardsByLabel[labelId] || [];
    const cardIndex = cardList.findIndex(card => card.id === cardId);

    if (cardIndex !== -1) {
      // Atualiza apenas os campos fornecidos em updatedData, mantendo os demais campos intactos
      const card = cardList[cardIndex];
      Object.keys(updatedData).forEach(key => {
        card[key] = updatedData[key];
      });
    }
  },
  // Mutation específica para atualizações reativas em tempo real
  [types.UPDATE_CARD_DATA_REACTIVE](_state, { cardId, updatedData }) {
    // Busca o card em todas as labels
    for (const labelId in _state.cardsByLabel) {
      const cardList = _state.cardsByLabel[labelId] || [];
      const cardIndex = cardList.findIndex(card => card.id === cardId);

      if (cardIndex !== -1) {
        const card = cardList[cardIndex];

        // Merge profundo dos dados atualizados
        Object.keys(updatedData).forEach(key => {
          if (
            typeof updatedData[key] === 'object' &&
            updatedData[key] !== null &&
            !Array.isArray(updatedData[key])
          ) {
            // Se for um objeto, fazer merge
            card[key] = { ...(card[key] || {}), ...updatedData[key] };
          } else {
            // Senão, substituir diretamente
            card[key] = updatedData[key];
          }
        });

        break; // Card encontrado, não precisa continuar procurando
      }
    }
  },
};
